import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

/* -------------------- ALL REVIEWS -------------------- */
export const AllReviewsThunk = createAsyncThunk(
  "reviews/AllReviewsThunk",
  async (_, { rejectWithValue }) => {
    try {
      const response = await axios.get(`/api/reviews/list`);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || "Failed to fetch reviews");
    }
  }
);

/* -------------------- GET SINGLE REVIEW -------------------- */
export const GetSingleReviewThunk = createAsyncThunk(
  "reviews/GetSingleReviewThunk",
  async (uuid, { rejectWithValue }) => {
    try {
      const response = await axios.get(`/api/reviews/show?uuid=${uuid}`);
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data || "Failed to fetch review details"
      );
    }
  }
);

/* -------------------- ADD REVIEW -------------------- */
export const AddReviewThunk = createAsyncThunk(
  "reviews/AddReviewThunk",
  async (formData, { rejectWithValue }) => {
    try {
      const response = await axios.post(`/api/reviews/add`, formData);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || "Failed to add review");
    }
  }
);

/* -------------------- UPDATE REVIEW -------------------- */
export const UpdateReviewThunk = createAsyncThunk(
  "reviews/UpdateReviewThunk",
  async ({ uuid, formData }, { rejectWithValue }) => {
    try {
      const payload = { ...formData, uuid };
      const response = await axios.post(`/api/reviews/update`, payload);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || "Failed to update review");
    }
  }
);

/* -------------------- DELETE REVIEW -------------------- */
export const DeleteReviewThunk = createAsyncThunk(
  "reviews/DeleteReviewThunk",
  async (uuid, { rejectWithValue }) => {
    try {
      const response = await axios.get(`/api/reviews/delete?uuid=${uuid}`);
      return {
        uuid,
        message: response.data?.message || "Review deleted successfully",
      };
    } catch (error) {
      return rejectWithValue(error.response?.data || "Failed to delete review");
    }
  }
);


/* -------------------- ALL REVIEWS -------------------- */
export const AllProdutListThunk = createAsyncThunk(
  "reviews/AllProdutListThunk",
  async (_, { rejectWithValue }) => {
    try {
      const response = await axios.get(`/api/reviews/pruduct-list`);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || "Failed to fetch reviews");
    }
  }
);

/* -------------------- ALL User List -------------------- */
export const AllUserListThunk = createAsyncThunk(
  "reviews/AllUserListThunk",
  async (_, { rejectWithValue }) => {
    try {
      const response = await axios.get(`/api/reviews/users-list`);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || "Failed to fetch reviews");
    }
  }
);